import { render } from "./ConcentracionRiesgo.vue?vue&type=template&id=1bae8272&scoped=true"
import script from "./ConcentracionRiesgo.vue?vue&type=script&lang=js"
export * from "./ConcentracionRiesgo.vue?vue&type=script&lang=js"

import "./ConcentracionRiesgo.vue?vue&type=style&index=0&id=1bae8272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bae8272"]])

export default __exports__